export { Text as default } from './Text';
